import { MessageInputBox, ReplyMessageInputBox } from "../MessagePanel.style";
import { ReplyBubbleHeaderComponent } from "../messageType/ReplyBubble";
import MentionInputBox from "./MentionInputBox";
import React from "react";
import {
  CHAT_TYPE,
  IFileAndCaption,
  IMessage,
  ImmutableChat,
} from "@home-health-notify/domain";

interface InputMessageBoxProps {
  replyMessage?: IMessage;
  onAdd: (id: string) => void;
  onChange: (
    event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement> | unknown,
    newValue: string,
    newPlainTextValue: string,
  ) => void;
  chatMessage: string;
  send: () => Promise<void>;
  chat: ImmutableChat;
  onRemove: (id: string) => void;
  mentionedUsers: string[];
  onPasteFile: (fileList: IFileAndCaption[]) => Promise<void>;
  disableMention?: boolean;
}

export const InputMessageBox = ({
  replyMessage,
  onAdd,
  onChange,
  chatMessage,
  send,
  chat,
  onRemove,
  mentionedUsers,
  onPasteFile,
  disableMention = false,
}: InputMessageBoxProps) => {
  const isBroadcastChat = chat.getChatType() === CHAT_TYPE.BROADCAST;
  const shouldDisableMention = isBroadcastChat || disableMention;
  return (
    <ReplyMessageInputBox>
      {replyMessage ? (
        <>
          <ReplyBubbleHeaderComponent
            message={replyMessage}
            isReply={true}
            isReplyPreview={true}
          />
          <MentionInputBox
            chat={chat}
            onAdd={onAdd}
            onChange={onChange}
            chatMessage={chatMessage}
            send={send}
            disableMention={shouldDisableMention}
            replyMessage={replyMessage}
            mentionedUsers={mentionedUsers}
            onRemove={onRemove}
            onPasteFile={onPasteFile}
          />
        </>
      ) : (
        <MessageInputBox>
          <MentionInputBox
            chat={chat}
            onAdd={onAdd}
            onChange={onChange}
            chatMessage={chatMessage}
            send={send}
            disableMention={shouldDisableMention}
            replyMessage={replyMessage}
            mentionedUsers={mentionedUsers}
            onRemove={onRemove}
            onPasteFile={onPasteFile}
          />
        </MessageInputBox>
      )}
    </ReplyMessageInputBox>
  );
};
